import React, { useEffect, useRef } from 'react';
import * as S from './amenities.styles';
import { AnimatedBackground } from '../../Common/dweb-common.styles';
const skeltonAmenities = new Array(8).fill('-');

function Amenities({ loadingAmenties = false, amenitiesData, handleTracking }) {
  const initialRenderRef = useRef(false);
  const { amenity_list: amenities = [], tracking = {} } = amenitiesData || {};

  useEffect(() => {
    if (!initialRenderRef.current && amenities?.length) {
      const trackingObj = {
        ...(tracking || {})
      };

      if (tracking?.pdt_events) {
        trackingObj.pdt_events = trackingObj.pdt_events.map(action => {
          return action?.replace('{{count}}', amenities?.length || 0);
        });
      }
      handleTracking(trackingObj, {
        replaceEventData: cta => {
          return {
            ...cta,
            name: cta?.name?.replace('{{count}}', amenities.length) || cta?.name
          };
        }
      });
      initialRenderRef.current = true;
    }
  }, [amenitiesData]);

  if (!amenities?.length && !loadingAmenties) {
    return null;
  }

  return (
    <S.AmenitiesContainer className={loadingAmenties && 'justifyBetween'}>
      {(loadingAmenties ? skeltonAmenities : amenities).map((feature, index) => (
        <S.AmenitiesItem key={index}>
          {loadingAmenties ? (
            <AnimatedBackground height="16px" width="100%" />
          ) : (
            <>
              <S.AmenitiesIcon src={feature.icon} width="16" height="16" />
              <S.AmenitiesText className="greyCnt">{feature.text}</S.AmenitiesText>
            </>
          )}
        </S.AmenitiesItem>
      ))}
    </S.AmenitiesContainer>
  );
}

export default Amenities;
